import { faker } from '@faker-js/faker'
import { defineFakeRoute } from 'vite-plugin-fake-server/client'

export default defineFakeRoute([
  {
    url: '/mock/api/base/login',
    method: 'post',
    response: ({ body }) => {
      return {
        code: 0,
        data: {
          token: `${body.account}:${faker.internet.jwt()}`,
          user: {
            account: body.account,
            nickname: faker.person.fullName(),
            photo: 'https://fantastic-admin.hurui.me/logo.svg',
          },
        },
        msg: '',
      }
    },
  },
  {
    url: '/mock/user/permission',
    method: 'get',
    response: ({ headers }) => {
      let permissions: string[] = []
      if (headers.token?.indexOf('admin') === 0) {
        permissions = [
          'permission.browse',
          'permission.create',
          'permission.edit',
          'permission.remove',
        ]
      }
      else if (headers.token?.indexOf('test') === 0) {
        permissions = [
          'permission.browse',
        ]
      }
      return {
        code: 0,
        data: {
          permissions,
        },
        msg: '',
      }
    },
  },
  {
    url: '/mock/user/password/edit',
    method: 'post',
    response: () => {
      return {
        code: 0,
        data: {
          isSuccess: true,
        },
        msg: '',
      }
    },
  },
])
